module.exports = __webpack_public_path__ + "img/img_fukuan.a327bdd8.png";